import React, { Fragment } from 'react';
import Frame from './components/frame';

import Header from './components/header';
import ContentHeader from './components/contentheader';
import Steps from './components/steps';
import Button from './components/button';
import { connect } from 'react-redux';

import { updatePageNumber } from './actions/global-actions';

import Page1 from './pages/page1';
import Page2 from './pages/page2';
import Page3 from './pages/page3';

//Global Stylesheets
import './static/css/general/reset.scss';
import './static/css/general/typographie.css';
import './static/css/general/spacing.css';
import './static/css/general/base.css';

import s from './static/css/general/app.module.css';
import { queryParams } from './utils';

class App extends React.Component {

	componentDidMount() {
		const q = queryParams();
		if (q.iframe) {
			window.parent.postMessage({
				type: 'pageUpdate',
				payload: 'LOAD_BOOKING_FORM'
			}, '*');

			window.addEventListener("resize", () => {
				sendHeight();
			});

			const sendHeight = () => window.parent.postMessage({
				type: 'iframeHeight',
				payload: document.body.scrollHeight
			}, '*');

			this.observer = new MutationObserver(sendHeight);
			this.observer.observe(document, {
				attributes: true,
				childList: true,
				subtree: true,
			});
		}
	}

	goToPage(e) {
		this.setState({ page: parseInt(e.target.getAttribute('data-page')) })
	}

	handleNext(e) {
		this.props.updatePageNumber(1)
	}

	openContactform() {
		window.open("https://www.gen25.com/en/contact/#contact-form");
	}
	handleNothing() { }

	handlePrev(e) {
		this.props.updatePageNumber(-1)
	}
	render() {
		return (
			<Fragment>
				<div className={s.topSpacer}></div>
				<Frame className={s.contentGrid}>
					{
						this.props.page !== 3 && 
						<Fragment>
							<Steps 
								active={this.props.page}
								onClick={() => { this.props.page === 2 ? this.handlePrev() : this.handleNothing() }} />
						</Fragment>
					}
					{
						this.props.page === 1 && 
						<Fragment>
							<ContentHeader value={"Select a time & date"} />
							<Page1 />
						</Fragment>
					}
					{
						this.props.page === 2 && 
						<Fragment>
							<ContentHeader value={"Enter your personal details"} />
							<Page2 />
						</Fragment>
					}
					{
						this.props.page === 3 && 
						<Fragment>
							<Page3 />
						</Fragment>
					}
					{
						this.props.page !== 3 && 
						<div className={s.buttonWrapper} id="buttonWrapperId">
							{this.props.page === 1 ?
								<div className={s.btnContactForm}>
									<a className={s.btn} href="https://www.gen25.com/en/contact/#contact-form">Request Timeslot</a>
								</div>
							: ""
							}
							<Button onClick={this.handleNext.bind(this)} id="nextBtn" outline={false}  buttonState={this.props.nextBtn}>
								{this.props.page === 2 ? 'Confirm' : 'Next'}
							</Button>
						</div>
					}
				</Frame>
				<div className={s.spacer}></div>
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	const { nextBtn, page } = state.global;
	return { nextBtn, page };
}

export default connect(mapStateToProps, { updatePageNumber })(App); 
